import {DashboardTerminalDto} from "./dashboard-terminal.dto";
import {ConfigLevel} from "./interfaces/config-level";
import {ConfigLevelType} from "./enums/config-level-type.enum";
import {Serialisable} from "../serialisable";

export class BranchDto extends Serialisable implements ConfigLevel {
    id: number;
    configId: number;
    configBranchId: number;
    name: string;
    getDisplayName(): string {
        return this.name;
    }

    terminals: DashboardTerminalDto[];

    minVersion: string;
    maxVersion: string;

    canUseCloudDeployments: boolean;

    configLevel = ConfigLevelType.Branch;
    getChildren(): ConfigLevel[] {
        return this.terminals;
    }
    setChildren(value: DashboardTerminalDto[]) : void  {
        this.terminals = value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/branch.dto.ts